import { useState } from "react";
import { IonButton, IonIcon, IonSpinner, IonContent, IonList, IonItem, IonLabel } from "@ionic/react";
import { ellipsisHorizontal } from "ionicons/icons";
import FreshPopover from "@/components/FreshPopover";

// A list row's actions. On a wide screen they are the row's icon buttons; on
// the phone they fold into one menu button whose popover lists them (the
// /app dropdown design: 240px, inset separators, none under the last), so
// the row stays one line, the height of a plain avatar row.
//
//   <RowActions isMobile={isMobile} actions={[
//     { key, icon, label, run, color?: "danger", busy?, disabled?, count? },
//   ]} />
//
// `count` is a small red pill on that button (and on the menu button, summed).
// `slot`: inside an ion-item the cluster sits in that slot ("end")
export default function RowActions({ actions = [], isMobile = false, className = "sig-actions", slot }) {
  const [menu, setMenu] = useState({ open: false, event: undefined });
  const close = () => setMenu({ open: false, event: undefined });
  const pill = (n) => (n > 0 ? <span className="sig-comment-count">{n > 9 ? "9+" : n}</span> : null);
  const list = actions.filter(Boolean);
  if (!list.length) return null;

  if (!isMobile) {
    return (
      <div className={`row-actions ${className}`.trim()} slot={slot}>
        {list.map((a) => (
          <IonButton key={a.key} fill="clear" size="small" className="app-row-icon-btn" color={a.color} disabled={a.busy || a.disabled}
            style={a.count != null ? { position: "relative", overflow: "visible" } : undefined}
            onClick={(e) => { e.stopPropagation(); a.run(); }} aria-label={a.label} title={a.title || a.label}>
            {a.busy ? <IonSpinner name="crescent" style={{ width: 18, height: 18 }} /> : <IonIcon slot="icon-only" icon={a.icon} />}
            {pill(a.count)}
          </IonButton>
        ))}
      </div>
    );
  }

  const total = list.reduce((n, a) => n + (a.count || 0), 0);
  const anyBusy = list.some((a) => a.busy);
  return (
    <div className={`row-actions ${className}`.trim()} slot={slot}>
      <IonButton fill="clear" size="small" className="app-row-icon-btn" style={{ position: "relative", overflow: "visible" }}
        onClick={(e) => { e.stopPropagation(); setMenu({ open: true, event: e.nativeEvent }); }} aria-label="Actions" title="Actions">
        {anyBusy ? <IonSpinner name="crescent" style={{ width: 18, height: 18 }} /> : <IonIcon slot="icon-only" icon={ellipsisHorizontal} />}
        {pill(total)}
      </IonButton>
      <FreshPopover open={menu.open} event={menu.event} onClose={close} side="bottom" alignment="end" style={{ "--width": "240px" }}>
        <IonContent>
          <IonList style={{ padding: "4px 0" }}>
            {list.map((a, i) => (
              <IonItem
                key={a.key}
                button
                detail={false}
                disabled={a.busy || a.disabled}
                lines={i === list.length - 1 ? "none" : "inset"}
                onClick={(e) => { e.stopPropagation(); close(); a.run(); }}
                style={{ "--min-height": "48px", "--padding-start": "14px", "--inner-padding-end": "14px", "--background": "transparent", "--color": a.color === "danger" ? "var(--ion-color-danger)" : "var(--ion-text-color)", "--border-color": "var(--app-divider)" }}
              >
                <IonIcon icon={a.icon} slot="start" style={{ fontSize: 18 }} />
                <IonLabel>{a.label}</IonLabel>
                {a.count > 0 && <span slot="end" className="admin-badge admin-badge-red">{a.count > 9 ? "9+" : a.count}</span>}
              </IonItem>
            ))}
          </IonList>
        </IonContent>
      </FreshPopover>
    </div>
  );
}
